import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicLayout from "./components/PublicLayout";

import Home from "./pages/Home";
import History from "./pages/History";
import Freemasonry from "./pages/Freemasonry";
import Visit from "./pages/Visit";
import Login from "./pages/Login";
import PaymentResult from "./pages/PaymentResult";

import PortalLayout from "./pages/portal/PortalLayout";
import Dashboard from "./pages/portal/Dashboard";
import CalendarPage from "./pages/portal/CalendarPage";
import Minutes from "./pages/portal/Minutes";
import Directory from "./pages/portal/Directory";
import Ritual from "./pages/portal/Ritual";
import Dues from "./pages/portal/Dues";
import Announcements from "./pages/portal/Announcements";
import Inquiries from "./pages/portal/Inquiries";
import Engagement from "./pages/portal/Engagement";
import MyProfile from "./pages/portal/MyProfile";
import Attendance from "./pages/portal/Attendance";
import Documents from "./pages/portal/Documents";
import News from "./pages/News";
import Article from "./pages/Article";
import ContentDashboard from "./pages/portal/cms/ContentDashboard";
import ContentEditor from "./pages/portal/cms/ContentEditor";
import MediaLibrary from "./pages/portal/cms/MediaLibrary";
import CmsUsers from "./pages/portal/cms/CmsUsers";
import ControlLogin from "./pages/control/ControlLogin";
import ControlLayout from "./pages/control/ControlLayout";
import Overview from "./pages/control/Overview";
import PlatformUsers from "./pages/control/PlatformUsers";
import ActivityLog from "./pages/control/ActivityLog";
import ControlDues from "./pages/control/ControlDues";

const publicPage = (Component) => (
  <PublicLayout>
    <Component />
  </PublicLayout>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={publicPage(Home)} />
          <Route path="/history" element={publicPage(History)} />
          <Route path="/freemasonry" element={publicPage(Freemasonry)} />
          <Route path="/visit" element={publicPage(Visit)} />
          <Route path="/news" element={publicPage(News)} />
          <Route path="/news/:slug" element={publicPage(Article)} />
          <Route path="/login" element={<Login />} />
          <Route path="/control-panel/login" element={<ControlLogin />} />
          <Route path="/control-panel" element={<ControlLayout />}>
            <Route index element={<Overview />} />
            <Route path="content" element={<ContentDashboard />} />
            <Route path="content/:id" element={<ContentEditor />} />
            <Route path="media" element={<MediaLibrary />} />
            <Route path="users" element={<PlatformUsers />} />
            <Route path="inquiries" element={<Inquiries />} />
            <Route path="dues" element={<ControlDues />} />
            <Route path="activity" element={<ActivityLog />} />
          </Route>
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult cancelled />} />

          <Route
            path="/portal"
            element={
              <ProtectedRoute>
                <PortalLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="profile" element={<MyProfile />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="minutes" element={<Minutes />} />
            <Route path="directory" element={<Directory />} />
            <Route path="ritual" element={<Ritual />} />
            <Route path="dues" element={<Dues />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="documents" element={<Documents />} />
            <Route
              path="engagement"
              element={
                <ProtectedRoute officerOnly>
                  <Engagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="attendance"
              element={
                <ProtectedRoute officerOnly>
                  <Attendance />
                </ProtectedRoute>
              }
            />
            <Route path="content" element={<ProtectedRoute cms="staff"><ContentDashboard /></ProtectedRoute>} />
            <Route path="content/:id" element={<ProtectedRoute cms="staff"><ContentEditor /></ProtectedRoute>} />
            <Route path="media" element={<ProtectedRoute cms="staff"><MediaLibrary /></ProtectedRoute>} />
            <Route path="cms-users" element={<ProtectedRoute cms="admin"><CmsUsers /></ProtectedRoute>} />
            <Route
              path="inquiries"
              element={
                <ProtectedRoute adminOnly>
                  <Inquiries />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
